// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StatsOrdersQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  endDate: Types.Scalars['ISO8601Date']['input'];
  endTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.OrderOrderByAttributes>;
  restaurantIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  startDate: Types.Scalars['ISO8601Date']['input'];
  startTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type StatsOrdersQuery = { __typename?: 'Query', stats: { __typename?: 'RestaurantStats', ordersConnection: { __typename?: 'OrderConnection', totalCount: number, nodes?: Array<{ __typename?: 'Order', id: string, hasRefund: boolean, hasLoyaltyTransactions: boolean, status: Types.OrderStatus, netItemSubtotal: number, netSales: number, number: string, paidAt?: string | null, paymentType?: Types.OrderPayment | null, processingFee: number, subtotal: number, tip: number, total: number, totalDiscountAmount: number, transferAmount?: number | null, giftCardTransaction?: { __typename?: 'GiftCardTransaction', id: string, amount?: number | null, giftCard: { __typename?: 'GiftCard', id: string, code: string } } | null, payments: Array<{ __typename?: 'Payment', id: string, paymentType: Types.OrderPayment }>, paymentUsers: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, phone?: string | null }>, purchasedGiftCard?: { __typename?: 'GiftCard', id: string, code: string, initialValue: number } | null, reaction?: { __typename?: 'Reaction', isPositive?: boolean | null, note?: string | null, reasons?: Array<{ __typename?: 'Reason', text: string }> | null } | null, refund?: { __typename?: 'Refund', id: string, subtotal?: number | null, tax?: number | null, processingFee?: number | null, total?: number | null, transferAmount?: number | null, createdAt: string, tip?: number | null } | null, restaurant: { __typename?: 'Restaurant', name?: string | null, timeZone: string }, streamOrder?: { __typename?: 'StreamOrder', sourceLabel: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } };

export type CreateOrderExportMutationVariables = Types.Exact<{
  input: Types.CreateOrderExportMutationInput;
}>;


export type CreateOrderExportMutation = { __typename?: 'Mutation', createOrderExport?: { __typename?: 'CreateOrderExportMutationPayload', success: boolean } | null };


export const StatsOrdersDocument = gql`
    query StatsOrders($after: String, $before: String, $endDate: ISO8601Date!, $endTime: Int, $first: Int, $last: Int, $orderBy: OrderOrderByAttributes, $restaurantIds: [ID!]!, $startDate: ISO8601Date!, $startTime: Int) {
  stats(
    endDate: $endDate
    endTime: $endTime
    restaurantIds: $restaurantIds
    startDate: $startDate
    startTime: $startTime
  ) {
    ordersConnection(
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
    ) {
      nodes {
        id
        giftCardTransaction {
          id
          amount
          giftCard {
            id
            code
          }
        }
        hasRefund
        hasLoyaltyTransactions
        status
        netItemSubtotal
        netSales
        number
        paidAt
        payments {
          id
          paymentType
        }
        paymentType
        paymentUsers {
          id
          name
          email
          phone
        }
        processingFee
        purchasedGiftCard {
          id
          code
          initialValue
        }
        reaction {
          isPositive
          reasons {
            text
          }
          note
        }
        refund {
          id
          subtotal
          tax
          tip: serviceFee
          processingFee
          total
          transferAmount
          createdAt
        }
        restaurant {
          name
          timeZone
        }
        streamOrder {
          sourceLabel
        }
        subtotal
        tip
        total
        totalDiscountAmount
        transferAmount
        user {
          id
          name
          email
          phone
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    `;

export function useStatsOrdersQuery(options: Omit<Urql.UseQueryArgs<StatsOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<StatsOrdersQuery, StatsOrdersQueryVariables>({ query: StatsOrdersDocument, ...options });
};
export const CreateOrderExportDocument = gql`
    mutation CreateOrderExport($input: CreateOrderExportMutationInput!) {
  createOrderExport(input: $input) {
    success
  }
}
    `;

export function useCreateOrderExportMutation() {
  return Urql.useMutation<CreateOrderExportMutation, CreateOrderExportMutationVariables>(CreateOrderExportDocument);
};